import * as reasonEndPoints from "../constants/endpoints/reason";
import axios from "../axios/axios";

export const getEventReasons = (eventName) => {
  return axios({
    url: `${reasonEndPoints.getEventReasons}/${eventName}`,
    method: "GET",
  });
};
